import styled, { css } from 'styled-components';

const borders = css`
  border-top: 5px solid ${props => props.theme.colors.claytonGreen};
  border-bottom: 5px solid ${props => props.theme.colors.claytonGreen};
`;

const CTACardv2Styles = styled.section`
    position: relative;
    padding: 0 ${props => props.theme.padding.inner} 1.75rem;
    
    h1, h2, h3, h4, h5, h6, p {
        margin: 0;
    }

    &::before {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        content: '';
        height: 5.1875rem;
        width: 100%;
        background: ${props => 
          props.backgroundTop 
            ? props.backgroundTop 
            : props.theme.colors.white};
        z-index: -1;
    }

    &::after {
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        content: '';
        height: calc(100% - 5.1875rem);
        width: 100%;
        background: ${props =>
        props.backgroundBottom 
          ? props.backgroundBottom 
          : props.theme.colors.darkBlue};
        z-index: -1;
        ${props => props.borders ? borders : null}
    }

  .inner {
    position: relative;
    display: flex;
    width: 100%;
    height: 404px;
    border: 2px solid rgb(0, 119, 200, 0.1);
    border-radius: 4px;
    overflow: hidden;
    background-color: white;
    margin: 0 auto 1.5rem;
    max-width: 404px;
    flex-direction: column;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: 1217px;
      height: 234px;
      flex-direction: row;
    }

    .skewed-primary {
      background-color: ${props => 
        props.backgroundPrimaryColor 
          ? props.backgroundPrimaryColor 
          : props.theme.colors.white};

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        left: -45px;
        transform: skew(340deg);
        position: absolute;
        width: 65%;
        height: 100%;
      }

      @media (max-width: ${props => props.theme.breakpoints.desktop}) {
        position: absolute;
        height: 50%;
        width: 100%;
      }

      .primary {
        align-content: center;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 3rem 1rem 0;
        height: 100%;
        flex-wrap: wrap;

        @media (min-width: ${props => props.theme.breakpoints.desktop}) {
          transform: skew(-340deg);
          align-items: flex-start;
          justify-content: center;
          padding: 0;
          width: 90%;
        }

        p {
          color: ${props => props.theme.colors.bedtime};
          text-transform: uppercase;
        }

        h2 {
          color: ${props => props.theme.colors.claytonBlue};
        }
      }
    }

    .skewed-secondary {
      background-color: ${props => 
        props.backgroundSecondaryColor 
          ? props.backgroundSecondaryColor 
          : props.theme.colors.blue10};
      height: 100%;

      @media (max-width: ${props => props.theme.breakpoints.desktop}) {
        display: ;
        content: '';
        position: absolute;
        border-radius: 50%;
        width: 120%;
        height: 100%;
        bottom: -40%;
        left: -11.5%;
        border: 5px solid ${props => 
          props.dividerColor 
            ? props.dividerColor 
            : props.theme.colors.claytonGreen};
        background-color: ${props => 
          props.backgroundSecondaryColor 
            ? props.backgroundSecondaryColor 
            : props.theme.colors.blue10};
      }

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        position: absolute;
        right: -42px;
        transform: skew(340deg);
        width: 45%;
      }

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        &::after {
          position: absolute;
          top: 20px;
          left: 0;
          height: 85%;
          width: 3px;
          content: '';
          background-color: ${props => 
            props.dividerColor 
              ? props.dividerColor 
              : props.theme.colors.claytonGreen};
          position: absolute;
        }
      }

      .secondary {
        width: 100%;
        flex-direction: column;
        align-content: center;
        flex-wrap: wrap;
        position: absolute;
        
        p, a {
          color: ${props => props.theme.colors.bedtime};
        }

        @media (min-width: ${props => props.theme.breakpoints.desktop}) {
          transform: skew(-340deg);
          height: 100%;
          display: flex;
          justify-content: center;
          height: 100%;
        }

        @media (max-width: ${props => props.theme.breakpoints.desktop}) {
          left: -11%;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-wrap: wrap;
          flex-direction: column;
          padding: 3rem;
          height: 60%;
          width: 100%;

          &:first-child {
            padding-top: 1rem;
          }
        }

        @media (max-width: ${props => props.theme.breakpoints.mobile}) { 
          left: 0;
          width: 80%;
          a {
            display: block;
          }
        }

        @media (max-width: ${props => props.theme.breakpoints.mobileSmall}) {
          padding-left: 2.5rem;
        }

        .links {
          display: flex;
          margin-bottom: 1rem;

          a {
            background-color: ${props => 
              props.buttonColor 
                ? props.buttonColor 
                : props.theme.colors.claytonBlue};
            color: ${props => props.theme.colors.white};

            &:hover {
              background-color: ${props => 
                props.backgroundSecondaryColor 
                  ? props.backgroundSecondaryColor 
                  : props.theme.colors.blue10};
              color: ${props => props.theme.colors.claytonBlue};
            }
          }
        }

        .cta-intro {
          * {
              font-size: ${props => props.theme.type.paragraph.intro};
              @media (max-width: ${props => props.theme.breakpoints.mobile}) {
                font-size: ${props => props.theme.type.paragraph.default};
                line-height: 1.15;
              }
          }
              
          p {
            @media (max-width: ${props => props.theme.breakpoints.mobile}) {
              padding-bottom: 1rem;
            }
          }
        }
      }
    }
  }
`;

export default CTACardv2Styles;
